export interface Utility {
  name: string;
  utilityApiId?: string;
  bayouId?: string;
  preference: "bayou" | "utilityApi" | "coned" | "false";
}

const utilities: Record<string, Utility> = {
  aes_indiana: {
    name: "AES Indiana",
    bayouId: "aes_indiana",
    preference: "bayou",
  },
  american_electric_power_ohio: {
    name: "American Electric Power Ohio",
    utilityApiId: "AEPOHIO",
    preference: "utilityApi",
  },
  alabama_power: {
    name: "Alabama Power",
    utilityApiId: "ALPower",
    preference: "utilityApi",
  },
  ameren: {
    name: "Ameren",
    utilityApiId: "Ameren",
    bayouId: "ameren",
    preference: "bayou",
  },
  appalachian_power: {
    name: "Appalachian Power",
    utilityApiId: "AppalachianPower",
    preference: "utilityApi",
  },
  arizona_public_service: {
    name: "Arizona Public Service Company",
    utilityApiId: "APS",
    bayouId: "arizona_public_service",
    preference: "utilityApi",
  },
  atlantic_city_electric: {
    name: "Atlantic City Electric",
    utilityApiId: "ACE",
    preference: "utilityApi",
  },
  austin_energy: {
    name: "Austin Energy",
    utilityApiId: "AustinEnergy",
    bayouId: "austin_utilities",
    preference: "bayou",
  },
  baltimore_gas_and_electric: {
    name: "Baltimore Gas & Electric",
    utilityApiId: "BGE",
    bayouId: "baltimore_gas_and_electric",
    preference: "utilityApi",
  },
  cleveland_electric_illuminating_company: {
    name: "Cleveland Electric Illuminating Company",
    utilityApiId: "CEIC",
    preference: "utilityApi",
  },
  central_hudson: {
    name: "Central Hudson",
    bayouId: "central_hudson",
    preference: "bayou",
  },
  citizens_energy: {
    name: "Citizens Energy",
    bayouId: "citizens_energy",
    preference: "bayou",
  },
  commonwealth_edison: {
    name: "Commonwealth Edison",
    utilityApiId: "ComEd",
    bayouId: "commonwealth_edison",
    preference: "bayou",
  },
  con_ed_ny: {
    name: "Consolidated Edison New York",
    utilityApiId: "ConEd",
    bayouId: "con_edison",
    preference: "coned",
  },
  dte_energy: {
    name: "DTE Energy",
    bayouId: "dte_energy",
    preference: "bayou",
  },
  dominion_energy: {
    name: "Dominion Energy",
    utilityApiId: "DOMINION",
    preference: "utilityApi",
  },
  duke_energy: {
    name: "Duke Energy",
    utilityApiId: "Duke",
    bayouId: "duke_energy",
    preference: "utilityApi",
  },
  el_paso_electric: {
    name: "El Paso Electric",
    bayouId: "el_paso_electric",
    preference: "bayou",
  },
  entergy: {
    name: "Entergy",
    bayouId: "entergy",
    preference: "bayou",
  },
  eversource_energy: {
    name: "Eversource Energy",
    utilityApiId: "EVRSRC",
    bayouId: "eversource",
    preference: "utilityApi",
  },
  florida_power_and_light: {
    name: "Florida Power and Light Company",
    utilityApiId: "FPL",
    bayouId: "florida_power_and_light",
    preference: "bayou",
  },
  georgia_power: {
    name: "Georgia Power",
    utilityApiId: "GAPower",
    bayouId: "georgia_power",
    preference: "utilityApi",
  },
  hawaii_electric: {
    name: "Hawaii Electric",
    utilityApiId: "HECO",
    preference: "utilityApi",
  },
  jersey_central_power_and_light: {
    name: "Jersey Central Power and Light",
    utilityApiId: "JCPL",
    bayouId: "jersey_central_power_and_light",
    preference: "utilityApi",
  },
  los_angeles_department_of_water_and_power: {
    name: "Los Angeles Department of Water & Power",
    utilityApiId: "LADWP",
    bayouId: "los_angeles_department_of_water_and_power",
    preference: "bayou",
  },
  mon_power: {
    name: "Mon Power",
    utilityApiId: "MonPower",
    preference: "utilityApi",
  },
  national_grid: {
    name: "National Grid (Other)",
    utilityApiId: "NATGD",
    preference: "utilityApi",
  },
  national_grid_new_york: {
    name: "National Grid (Upstate New York Only)",
    utilityApiId: "NGNY",
    bayouId: "national_grid_new_york",
    preference: "utilityApi",
  },
  nevada_energy: {
    name: "Nevada Energy",
    utilityApiId: "NVE",
    preference: "utilityApi",
  },
  new_york_state_electric_and_gas_corporation: {
    name: "New York State Electric and Gas Corporation",
    utilityApiId: "NYSEG",
    bayouId: "nyseg",
    preference: "bayou",
  },
  ohio_edison: {
    name: "Ohio Edison",
    utilityApiId: "OhioEd",
    preference: "utilityApi",
  },
  orange_and_rockland_utilities: {
    name: "Orange and Rockland Utilities",
    utilityApiId: "ORU",
    bayouId: "orange_and_rockland",
    preference: "coned",
  },
  pacific_gas_and_electric: {
    name: "Pacific Gas and Electric",
    utilityApiId: "PG&E",
    preference: "utilityApi",
  },
  pacific_power: {
    name: "Pacific Power",
    utilityApiId: "PacPower",
    bayouId: "pacific_power",
    preference: "utilityApi",
  },
  peco_energy: {
    name: "PECO Energy",
    utilityApiId: "PECO",
    bayouId: "peco",
    preference: "bayou",
  },
  penelec: {
    name: "Penelec",
    utilityApiId: "Penelec",
    preference: "utilityApi",
  },
  potomac_electric_power_company: {
    name: "Potomac Electric Power Company",
    utilityApiId: "PEPCO",
    bayouId: "pepco",
    preference: "bayou",
  },
  portland_general_electric: {
    name: "Portland General Electric",
    bayouId: "portland_general_electric",
    utilityApiId: "PORTGE",
    preference: "bayou",
  },
  potomac_edison: {
    name: "Potomac Edison",
    utilityApiId: "PotomacEd",
    bayouId: "potomac_edison",
    preference: "utilityApi",
  },
  pennsylvania_power_and_light: {
    name: "Pennsylvania Power and Light",
    utilityApiId: "PPL",
    preference: "utilityApi",
  },
  public_services_electric_and_gas: {
    name: "Public Services Electric and Gas",
    utilityApiId: "PSEG",
    bayouId: "pseg_new_jersey",
    preference: "utilityApi",
  },
  public_services_electric_and_gas_long_island: {
    name: "Public Services Electric and Gas - Long Island",
    utilityApiId: "PSEGLI",
    bayouId: "pseg_long_island",
    preference: "utilityApi",
  },
  public_service_company_of_new_mexico: {
    name: "Public Service Company of New Mexico",
    bayouId: "public_service_company_of_new_mexico",
    preference: "bayou",
  },
  public_service_company_of_oklahoma: {
    name: "Public Service Company of Oklahoma",
    utilityApiId: "PSO",
    preference: "utilityApi",
  },
  puget_sound_energy: {
    name: "Puget Sound Energy",
    bayouId: "puget_sound_energy",
    preference: "bayou",
  },
  rocky_mountain_power: {
    name: "Rocky Mountain Power",
    utilityApiId: "RMP",
    preference: "utilityApi",
  },
  san_diego_gas_and_electric: {
    name: "San Diego Gas and Electric",
    utilityApiId: "SDG&E",
    bayouId: "san_diego_gas_and_electric",
    preference: "utilityApi",
  },
  san_francisco_public_utilities_commission: {
    name: "San Francisco Public Utilities Commission",
    utilityApiId: "SFPUC",
    preference: "utilityApi",
  },
  seattle_city_light: {
    name: "Seattle City Light",
    bayouId: "seattle_city_light",
    preference: "bayou",
  },
  sacramento_municipal_utility_district: {
    name: "Sacramento Municipal Utility District",
    utilityApiId: "SMUD",
    bayouId: "sacramento_municipal_utility_district",
    preference: "bayou",
  },
  southern_california_edison: {
    name: "Southern California Edison",
    utilityApiId: "SCE",
    bayouId: "southern_california_edison",
    preference: "bayou",
  },
  southern_california_gas_company: {
    name: "Southern California Gas Company (SoCalGas)",
    utilityApiId: "SoCalGas",
    preference: "utilityApi",
  },
  salt_river_project: {
    name: "Salt River Project",
    utilityApiId: "SRP",
    preference: "utilityApi",
  },
  tucson_electric_power: {
    name: "Tucson Electric Power",
    utilityApiId: "TEP",
    preference: "utilityApi",
  },
  texas_gas_service: {
    name: "Texas Gas Service",
    utilityApiId: "TEXGAS",
    preference: "utilityApi",
  },
  washington_gas: {
    name: "Washington Gas",
    utilityApiId: "WashingtonGas",
    preference: "utilityApi",
  },
  west_penn_power: {
    name: "West Penn Power",
    utilityApiId: "WestPennPower",
    preference: "utilityApi",
  },
  xcel_energy: {
    name: "Xcel Energy",
    utilityApiId: "XCEL",
    bayouId: "xcel_energy",
    preference: "bayou",
  },
};

const filteredUtilities = Object.fromEntries(
  Object.entries(utilities).filter(
    ([, value]) => value.preference !== "false",
  ),
) as Record<string, Utility>;

export default filteredUtilities;
